module.exports = __webpack_public_path__ + "img/print.9bf05026.svg";